
import { defineComponent } from 'vue'
import AsahiTypography from '@/components/library/Typography.vue'

export default defineComponent({
  name: 'BasicModal',
  components: { AsahiTypography },

  props: {
    closeModal: {
      type: Function,
      default: () => {
        /*  */
      }
    },
    title: String,
    subtitle: String,
    description: String,
    icon: String
  },
  emits: ['closeModal'],
  methods: {

  }
})

